
import Product from "layouts/products/Product"
import ProtectedRoute from "./ProtectedRoute";
import Manage from "layouts/products/Manage";

const ProductRoutes = [
  {
    key: "editProduct",
    route: "/products/editProduct/:productId",
    component:<ProtectedRoute check="logout"><Product /></ProtectedRoute>,
  },
  {
    route: "/products/manage/:pageNo",
    key: "manage-product",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }
    
];
export default ProductRoutes;
